export const LOGIN_ADMIN = 'LOGIN_ADMIN'
export const PUSH_NOTIFICATION = 'PUSH_NOTIFICATION'
export const AUTH_SUCCESS = 'AUTH_SUCCESS'
export const LOGOUT = 'LOGOUT'
export const GET_USER_DATA = 'GET_USER_DATA'





